import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

class ListDesignItems extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            DesignItems : null
        };

        this.dsd = new dsd();
        this.dsd.StateObject = this;
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
        return;
    }

    setup(){
        let StateChange = {
            DesignItems: [],
            columns: {
                status: true
            },
            idDesign: null
        }

        if (getParam('DesignItems', this.props)){
            StateChange.DesignItems = getParam('DesignItems', this.props);
            StateChange.isLoaded = true;
        }

        if (getParam('columns', this.props)){
            StateChange.columns = getParam('columns', this.props);
        }

        if (getParam('idDesign', this.props)){
            StateChange.idDesign = getParam('idDesign', this.props);
        }

        this.setState(StateChange);
    }

    included(DesignItem) {
        let IncludeThis = true;
        return IncludeThis;
    }

    render() {
        if (this.state.isFailed) {
            return (
                <PD.ErrorBox>
                    A problem has occurred
                </PD.ErrorBox>
            )
        }

        if (this.state.isLoaded) {
            let arrDesignItems = this.state.DesignItems;
            if (isArray(arrDesignItems)){
                if (arrDesignItems.length > 0){
                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    {this.state.columns.status &&
                                        <PD.Th>Status</PD.Th>                            
                                    }
                                    <PD.Th>Reference</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>
                            {
                                arrDesignItems.map(
                                    (DesignItem, pos) => 
                                    {
                                        if (this.included(DesignItem)) {
                                            return (
                                                <PD.Tr key={pos}>
                                                    <PD.Td>
                                                        <PD.PdNavLink to={"/designitem/" + DesignItem._id}>{DesignItem.name}</PD.PdNavLink>
                                                    </PD.Td>
                                                    {this.state.columns.status &&
                                                        <PD.Td>
                                                            {DesignItem.status}
                                                        </PD.Td>
                                                    }                                                        
                                                    <PD.Td>
                                                        {DesignItem.reference}
                                                    </PD.Td>
                                                </PD.Tr>
                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>
                        </PD.Table>
                    )
                }
            }
        }

        return <div />;
    };    
};
        
// Wrap and export
export default function ListDesignItems_wrapper(props) {
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListDesignItems {...props} navigation={navigation} location={location} params={params} />;
}
